import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect }  from 'react-redux';

//import 'bootstrap/dist/css/bootstrap.min.css';
// dumb components
import { COLOR } from './constants';
//import {em, sizeResponsive, setListenerOrientation} from "../utils/FWResponsive";
import {platformHandler} from '../platforms/PlatformHandler'
import { languageManager } from '../utils/languageManager'
import {flipwitFirebaseConnector} from '../platforms/flipwitFirebaseConnector'
//import { userHandler } from '../platforms/UserHandler'
//import { Button } from 'reactstrap';
import { initialState } from './reducer';
//import { setSlideInfo, setSharePPT } from './actions';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

// import HelloWorld from '../components/HelloWorld';

// actions
//import { setOrientation, setKeyboard } from '../actions/actions';
//import * as firebase from 'firebase'

import { Switch, Route } from 'react-router-dom';
import { MemoryRouter } from 'react-router'
import Initial from '../scenes/Initial'
import Role from '../scenes/Role'
import Login from '../scenes/Login'
import SelectPresentation from '../scenes/SelectPresentation'
import UploadPresentation from '../scenes/UploadPresentation'
import PresentationMode from '../scenes/PresentationMode'
import PresentationUser from '../scenes/PresentationUser'
import ShareOption from '../scenes/ShareOption'
import WaitingSession from '../scenes/WaitingSession'
import BlockedUser from '../scenes/BlockedUser'
import MainMenu from '../scenes/MainMenu'
import SlideEditor from '../scenes/SlideEditor'

import { withStyles } from '@material-ui/core/styles';

import MenuFlipwit from '../components/MenuFlipwit';
import FwModalWindow from '../components/FW_ModalWindow';

var isElectron = false;
window.TITLES = {};
window.TEXTS = {};
window.TEXTS_LANG = {};
//window.DEBUG_FLIPWIT = platformHandler.debugFlipwit;
window.DEBUG_FLIPWIT = console.log;
console.DEBUG_FLIPWIT = console.log;

window.setMobileApp = function( platform ){//1 ios, 2 android
  platformHandler.setMobileApp(platform);
}
// console.log = () => {}; // useful to disable all logs and increase overall app performance mainly in mobile phones
/* Inicio bloque de escuchadores de funciones que se llaman desde el Electron */

if(window!==null && typeof window.require!== 'undefined') {
    isElectron = true;
    platformHandler.isElectron = true;
    var ipc = window.require('electron').ipcRenderer;
    
    ipc.on('testFuncion', function(data, msg) {
      console.DEBUG_FLIPWIT('ENTRO!!!!!!!!! ' + msg);
    });    

    ipc.on('closeElectron', function(data) {
      console.DEBUG_FLIPWIT('Cerrar session porque me salgo')
      if(!platformHandler.isCloud()) {
        //platformHandler.closeCurrentSession();
        platformHandler.onCloseElectron();
      }
    });
}
/* Fin bloque de Escuchadores de funciones que se llaman desde el Electron */

const themeSelection = createMuiTheme({
  palette: {
    /*primary: {
      light: COLOR.FLIPWIT_COLOR_2,
      main: COLOR.FLIPWIT_COLOR_2,
      dark: COLOR.FLIPWIT_COLOR_2,
      contrastText: '#FFF',
    },*/
    primary: {
      light: '#8CD2DC',
      main: '#6D9EC6',
      dark: '#608DB3',
      contrastText: '#FFF',
    },
    secondary: {
      light: COLOR.FLIPWIT_COLOR_0,
      main: COLOR.FLIPWIT_COLOR_1,
      dark: COLOR.FLIPWIT_COLOR_2,
      contrastText: '#FFF',
    }
  },
  overrides: {   
   MuiExpansionPanel: {
      expanded: {
        margin: 0,
        backgroundColor: "#EEE",
        zIndex: "1",
        borderTop: "2px solid lightgray",
        borderBottom: "1px solid lightgray",    
      },
      root: {
        '&:hover': {
                boxShadow: "inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15)",
                zIndex: "1",
              }
      },     
   },
   MuiMenuItem: {
      root: {
        fontSize: '0.875rem',
      }
    },
    MuiListItem: {
       root: {
        paddingTop: 4,
        paddingBottom: 4,        
      },
    },   
    MuiListItemText: {
      root: {padding: 0},
      primary: {fontSize: '1em'}
    },
    MuiFormControlLabel: {
      root: {height: 32,
            marginLeft: 22,
      },

    },
    MuiIconButton: {
      root: {
        height: 'auto',
      }
    },
    MuiRadio: {
      root: {
        color: 'inherit',
      }
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
      },
    },
    MuiExpansionPanelSummary: {
      content: {
        '&$expanded': {
          borderBottom: "1px solid darkgray",
          height: "100%",
          paddingBottom: "10px",
          borderBottom: "1px solid darkgray",
        }
      },
      root: {
        '&$expanded': {
          //height: "3em",
          minHeight: "auto",
        }
      },
      expanded: {
        height: "3em",
      }
    },   
  },  
  typography: {
    useNextVariants: true,
  },
});

/*const themeRole = createMuiTheme({
  palette: {
    primary: {
      light: COLOR.FLIPWIT_COLOR_2,
      main: COLOR.FLIPWIT_COLOR_2,
      dark: COLOR.FLIPWIT_COLOR_2,
      contrastText: COLOR.FLIPWIT_COLOR_2,
    },
    secondary: {
      light: COLOR.FLIPWIT_COLOR_1,
      main: COLOR.FLIPWIT_COLOR_1,
      dark: COLOR.FLIPWIT_COLOR_1,
      contrastText: COLOR.FLIPWIT_COLOR_1,
    }
  },
  overrides: {    
    MuiInput: {
      input: {
        width: '100%',
      },
      underline: {
        '&:before': {
          borderBottom: '2px solid rgba(0, 0, 0, 1)'
        }        
      }
    },    
  },  
});*/

const styles = theme => ({
  input: {
    display: 'none',
  },
  paperRoleSelection: {
    maxHeight: 320,
    width: 480,
    height: '50%',
    margin: '1.5%',    
  },
  flipwitContainer: {
    //height: '100%',
    display: 'flex',
    flexDirection: 'column',  
    flex: 1,
    width: '100%',
    height: '100%',
  },
  flipwitContent: {
    //height:'calc(100% - 30px)',
    display: 'flex',    
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',    
    overflowX: 'hidden',    
    flex: 1, 
    //minHeight: `${window.innerHeight - 64}px`,
    height: '100%',
    //minHeight: `${heightContent}px`,
    //minHeight: "calc( 100vh - 64px)",
  },
  paperContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  paperTitle: {
    backgroundColor: COLOR.FLIPWIT_COLOR_2,
    color: 'black',
    height: '17%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperContent: {
    padding: 12,
  },
  paperRoleSelectionDown: {    
  },
  labelTitlePaper: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.3em',
    color: 'white',
  },
  iconPaperTitle: {
    fontSize: '1.6em',
    margin: 8,
  },
  middleBoxPaper: {
    height: '55%',
    display: 'flex',
    //Se hace un translate en vez de usar margin ya que
    //el margin de arriba y abajo se calculan con el width
    //y no con el height y eso no sirve
    transform: 'translateY(20%)',
    margin: '0% 5%',
    fontSize: '0.9em',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  bottomBoxPaper: {
    height: '28%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  codeTextField: {
    width: '100%',  
    marginTop: '1.5em',
  },
  inputTest: {},
  button: {
    backgroundColor: COLOR.FLIPWIT_COLOR_3,
    color: 'white',
    width: '30%',
    minWidth: 100,
    '&:hover': {
      backgroundColor: COLOR.FLIPWIT_COLOR_4,
     }   
  },
  //Cuando no caben los 2 papers en la misma fila entonces los pone uno encima del 
  //otro y toma estos css adicionales
  [theme.breakpoints.down(1008)]: {
    paperRoleSelection: {
      width: 295,
      height: '45%',   
    },
    paperRoleSelectionDown: {           
    }
  },

  [theme.breakpoints.down(598)]: {
    paperRoleSelection: {
      alignSelf: 'flex-end',         
    },
    paperRoleSelectionDown: {
      alignSelf: 'flex-start',      
    }
  },
  '@media (max-height: 600px)': {   
    middleBoxPaper: {
      fontSize: '0.8em',      
    },
    codeTextField: {
      marginBottom: 0,
    },
    paperRoleSelection: {
      margin: '1% 8px',     
      height: '48%',  
    },
    flipwitContent: {
      //height:'calc(100% - 30px)',      
      position: 'relative',      
    },        
  },
  '@media (max-height: 450px)': {
    middleBoxPaper: {
      fontSize: '0.8em',      
    },
    codeTextField: {
      marginTop: -14,
      marginBottom: 0,
    },
    paperRoleSelection: {
      margin: '2px',     
      height: '50%',  
      minHeight: 170,
    },
    flipwitContent: {
      //height:'calc(100% - 30px)',      
      position: 'relative',     
    },    
    inputTest: {
      display: 'none',
    },
  },
  
});


class App extends Component {
  state = { navOpen: false, ready: false, expandedItems: [], key:0, keyboardVisible: false }

  constructor(props) {
    super(props);

    if(this.comChannels===undefined) {
      this.comChannels = [];
    }

    // Added this listener to reset sessions after web page reload!
    if (window!==null) {
      window.addEventListener('beforeunload', function(e) {
        //platformHandler.closeCurrentSession();
      });
    }
  }

  listenerOrientation = ( orientation, visible ) =>{
    //alert("it works " + orientation + " " + height)
    console.log("it works " + orientation + " " + visible)
    if( orientation === 'keyboard'){
        if( platformHandler.isMobileAndTablet ){
          this.setState({ keyboardVisible: visible })
          //this.props.dispatch( setKeyboard( visible ) );
        }
    }
    else{
      //this.props.dispatch( setOrientation( orientation ) );
      this.forceUpdate();

      platformHandler.orientationChange();
    }
    
  }

  loadedJSON = ( jsonData ) =>{
    //setListenerOrientation( this.listenerOrientation);

    let timeScriptWSH = 500;
    if( isElectron ){
      let path = window.require('path');
      let configFile = path.join( window.__dirname,'..', '..','..', 'configScript.json');
      console.log('configFile ' + configFile)
      try{
        let fs = window.require('fs');
        let fileConfig = fs.readFileSync( configFile, 'utf8' );
        let jsonConfig = JSON.parse(fileConfig)
        timeScriptWSH = jsonConfig.time;
      }
      catch( e ){
        console.log('there is not config file ' + e);
      }
    }
 
    //Tener en cuenta que en el electron se esta ejecutando un codigo que permite que el ondrag 
    //drag, allowDrag, y todo lo relacionado con drag and drop funcione bien en el electron

    console.log('the context', initialState)
    //this.props.dispatch( setSlideInfo(initialState.currentData) );
    //this.props.dispatch( setSharePPT(initialState.configPPT) );
    
    //Si recibe como codigo de conexion la palabra demo o la palabra demo seguido de un numero
    //entonces se va a ejecutar el modo demo
    //Si quiere poner el modo demo es porque el codigo de conexion es demo
    //Modo demo es un desarrollo para que un usuario sin autenticarse ni nada 
    //pueda iniciar como expositor una presentacion creada para mostrar las funcionalidades 
    //de flipwit    
    let isDemo = (/^demo(\d*)$/gi).test(window.codeByUrl);

    if(isDemo) {

      //Cuando me conecto a /demo es para iniciar un nuevo demo
      if(window.codeByUrl.toLowerCase()==="demo") {
        platformHandler.createNewDemo(() => {
          console.log('Termina de crear el demo')
          platformHandler.init(isElectron, timeScriptWSH, this.props.history);        
        });        
      }
      else {
        //Si ya me conecto por ejemplo a demo34 es para seguir como tal la conexion al demo ya creado 
        //desde mi celular
        platformHandler.connectToDemo(window.codeByUrl, (connections) => {

          if(connections==-1) {
            //TODO Que muestre que no existe el demo actual y lo lleve a Role o algo
            return;
          }
          
          console.log('Se conecta con conexiones=',connections)
          //De las conexiones que se hagan al demo, solo el primero se conecta tambien como presentador
          //los otros lo hacen como audiencia
          if(connections==1) {
            platformHandler.init(isElectron, timeScriptWSH, this.props.history);
          }
          //Para el usuario 2 en adelante se unen 
          else {
            platformHandler.init(isElectron, timeScriptWSH, this.props.history);
            platformHandler.joinDemoSession(window.codeByUrl);
          }
        });  
      }
    }
    else {
      platformHandler.init(isElectron, timeScriptWSH, this.props.history);      
    }


    platformHandler.setDispatch( this.props.dispatch );
    platformHandler.setStore( this.context.store.getState );

    platformHandler.setLanguage( jsonData );

    console.log('JSON CARGADOS',jsonData)

    this.setState({ ready: true })
  }

  componentDidMount() {
    
    /*var loaderDiv = document.getElementById("loaderDiv");
    loaderDiv.parentElement.removeChild(loaderDiv);*/
    //window.addEventListener("resize", this.updateDimensions);
    languageManager.init( this.loadedJSON, isElectron );    
  }

  /*updateDimensions = () => {
    this.forceUpdate();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }*/

  testFuncion(data) {
    console.DEBUG_FLIPWIT('ENTRO!!!!!!!!! al 2');
  }

  toggleNavOpen = () => {
    this.setState({ navOpen: !this.state.navOpen })
  }

  signOut = () => {
    this.toggleNavOpen();
    //platformHandler.closeCurrentSession();
    flipwitFirebaseConnector.signOut();
    platformHandler.openScene("Role");
  }

  changeScene = (scene) => {
    this.toggleNavOpen();
    platformHandler.openScene(scene);
  }

  _toggleExpandedItem = name => {
    const expandedItems = [...this.state.expandedItems]

    const index = expandedItems.indexOf(name)
    if (index === -1) return this.setState({ expandedItems: expandedItems.concat([name]) })

    expandedItems.splice(index, 1)
    this.setState({ expandedItems })
  }

  changeLanguage = (lang) => {
    languageManager.changeLanguage( lang, this.setLanguage );
  }

  setLanguage = ( jsonData ) => {
    platformHandler.setLanguage( jsonData );
    platformHandler.checkTitleBarScene( platformHandler.currentScene, false );
    this.forceUpdate();
    //this.routerRef.forceUpdate();
    //Actions.refresh({ });
    
  }

  renderLanguage = ( listValue, i ) =>{
    /*window.DEBUG_FLIPWIT('listValue', listValue )
    return ( <ListItem key={i} 
                       active={ listValue.value == this.context.store.getState().language } leftIcon="&#xE837;"
                       onPress={() => this.changeLanguage( listValue.value )}
                       primaryText={listValue.title} 
                       style={navStyles.nestedItem} /> );*/
  }

  setCommunicationChannel = (objMessage) => {    
    if(objMessage.command==="register") {
      console.log('Pushea',objMessage.id)
      this.comChannels.push({id:objMessage.id,channel:objMessage.comChannel});     
      console.log('Queda con ' + this.comChannels.length)
      return this.messageToChannels;       
    }
  }

  messageToChannels = (objMessage) => {

    console.log('Llega el mensaje ', objMessage)
    console.log(this.comChannels,this.comChannels.length,Object.keys(this.comChannels).length,this.comChannels)
    for (var i = this.comChannels.length - 1; i >= 0; i--) {
      console.log('comparando ',this.comChannels[i].id," y ",objMessage.id,"pos",i,"de",this.comChannels.length)
      if(this.comChannels[i].id===objMessage.id) {
        console.log('ENTRA IF')
        this.comChannels[i].channel(objMessage);
        return;
      }
      console.log('PASA IF',this.comChannels)
    }

    // for (var channel in this.comChannels) {
    //   console.log('comparando ',channel," y ",objMessage.id)
    //   if(channel==objMessage.id) {
    //     console.log('ENTRA IF')
    //     this.comChannels[channel](objMessage);
    //     return;
    //   }
    //   console.log('PASA IF',this.comChannels)
    // }
    
  }

  render() {


    if(!this.state.ready) return null;
    console.log('contextTypes', this.props)

    const { classes, theme } = this.props;
    console.log("WD",theme)

    console.log(this.context.store.getState())

    return(
      <React.Fragment>
        <MuiThemeProvider theme={themeSelection}>
          <div className={classes.flipwitContainer}>
            <FwModalWindow />
            <MenuFlipwit> </MenuFlipwit>
            <div id="flipwitContent" className={classes.flipwitContent}>   
              <MemoryRouter>
                <Switch>
                  <Route exact path="/" component={Initial} />
                  <Route exact path="/Role" component={Role} />
                  <Route exact path="/Login" component={Login} />
                  <Route exact path="/SelectPresentation" component={SelectPresentation} />
                  <Route exact path="/UploadPresentation" component={UploadPresentation} />
                  <Route exact path="/MainMenu" component={MainMenu} />
                  <Route exact path="/PresentationMode" component={PresentationMode} />
                  <Route exact path="/PresentationUser" component={PresentationUser} />
                  <Route exact path="/ShareOption" component={ShareOption} />
                  <Route exact path="/WaitingSession" component={WaitingSession} /> 
                  <Route exact path="/BlockedUser" component={BlockedUser} /> 
                  <Route exact path="/SlideEditor" component={SlideEditor} /> 
                </Switch>
              </MemoryRouter>
            </div>
          </div>
        </MuiThemeProvider>      
      </React.Fragment>
    );    
  }
}

App.contextTypes = {
  store: PropTypes.object
};

App.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
};

const mapStateToProps = state => {  
  return {
    modalWindow: state.containers.appReducer.modalWindow,    
  }
};

/*const select = state => state;*/

// Wrap the component to inject dispatch and state into it
//export default connect()(withStyles(styles,{ withTheme: true })(App));
export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(App));

/*const navStyles = {
  avatarBox: {
    backgroundColor: '#ff5722',
    padding: 20
  },
  listItem:{
    flexDirection: 'row',
    flex: 1,
    padding: 0,
  },
  avatarImg: {
    width: 60,
    height: 60,
    marginVertical: 15
  },
  username: {
    color: COLOR.TEXT_WHITE
  },
  nestedItem: { 
    flexDirection: 'row',
    flex: 1,
    paddingLeft: "10%",
  },
}*/



// WEBPACK FOOTER //
// ./src/containers/App/index.js